"use client"

const ContactUsSection = ({ onHealthcareClick, onPatientClick }) => {
  return (
    <section className="py-24 bg-stone-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-emerald-800 mb-4">
            Contact Us
          </h2>
          <p className="text-lg text-charcoal-600 max-w-2xl mx-auto">
            Get in touch with our team for professional inquiries or patient support
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8">
          {/* Healthcare Professionals Box */}
          <div className="bg-white p-10 rounded-2xl border border-stone-200 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
            <div className="text-center">
              <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-10 h-10 text-emerald-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                  />
                </svg>
              </div>
              <h3 className="text-2xl font-semibold text-charcoal-800 mb-4">
                Enquire as Healthcare professionals
              </h3>
              <p className="text-charcoal-600 mb-8">
                Professional inquiries, product information, and partnership opportunities
              </p>
              <button
                onClick={onHealthcareClick}
                className="w-full bg-emerald-800 hover:bg-emerald-700 text-white py-3 px-6 rounded-lg font-medium shadow-md transition-colors duration-200"
              >
                Contact Us
              </button>
            </div>
          </div>
          {/* Patient Support Box */}
          <div className="bg-white p-10 rounded-2xl border border-stone-200 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
            <div className="text-center">
              <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-10 h-10 text-blue-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192L5.636 18.364M12 2.25a9.75 9.75 0 109.75 9.75A9.75 9.75 0 0012 2.25zm0 0v6m0 6v6"
                  />
                </svg>
              </div>
              <h3 className="text-2xl font-semibold text-charcoal-800 mb-4">
                Enquire as Patient- Product Support
              </h3>
              <p className="text-charcoal-600 mb-8">
                Get help with your device, troubleshooting, and general support
              </p>
              <button
                onClick={onPatientClick}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 px-6 rounded-lg font-medium shadow-md transition-colors duration-200"
              >
                Get Support
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ContactUsSection